import { Get } from "../../../api/apiHelper";
import { BillType } from "../../../interfaces/BillInterfaces";

const billingRoot = "/api/bills";

async function getClientBills(clientId: number): Promise<BillType[]> {
  const response = await Get(`${billingRoot}`, true, { clientId });
  return response.data as BillType[];
}

export default getClientBills;
